import { render, staticRenderFns } from "./PageSubFooter.vue?vue&type=template&id=199d59be&"
import script from "./PageSubFooter.vue?vue&type=script&setup=true&lang=js&"
export * from "./PageSubFooter.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PageSubFooter.vue?vue&type=style&index=0&id=199d59be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports